module.exports = __webpack_public_path__ + "img/img_level_20.80dd1c57.png";